import React from "react";
import { LexicalEditor as CommonLexicalEditor } from "cp-common-ui-components";
import "./LexicalEditor.scss";
interface LexicalEditorProps {
    messageBody: string;
    styles?: React.CSSProperties;
    changeStateEditorBody: (messageBody: string) => void;
}
// Giving the type as any since OptionType is not exported from the package
const lexicalEditorOptions: any = [
    "bold",
    "italic",
    "bgColorPicker",
    "colorPicker",
    "alignments",
    "numberList",
    "bulletList",
    "adjust",
    "clearFormat",
    "linkImage",
];
const defaultMessageBody = "<p></p>";

const LexicalEditor = (props: LexicalEditorProps) => {
    const { messageBody, styles, changeStateEditorBody } = props;
    return (
        <CommonLexicalEditor
            options={lexicalEditorOptions}
            messageBody={messageBody || defaultMessageBody}
            changeStateEditorBody={changeStateEditorBody}
            style={{ border: "none", ...styles }}
        />
    );
};
export default LexicalEditor;
